if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus');

			// In the cart there's no add-to-cart button to disable below MOQ, so the
			// pack size is a hard floor there instead of just a warning threshold.
			const isCartContext = !!this.querySelector('cart-product-quantity');

			let qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999,
					qtyStep = qty.getAttribute('step') ? parseInt(qty.getAttribute('step')) : 1,
					qtyMOQ = qty.getAttribute('data-moq') ? parseInt(qty.getAttribute('data-moq')) : qtyStep;

			let qtyMin = isCartContext ? qtyMOQ : 1;

			const packSizes = this.dataset.packSizes ? JSON.parse(this.dataset.packSizes) : null;
			const addToCartBtn = this.closest('.flex-buttons') ? this.closest('.flex-buttons').querySelector('[data-js-product-add-to-cart]') : null;
			const moqMessage = document.querySelector('[data-moq-message]');

			const updateDisabled = (val) => {
				qtyMinus.classList.toggle('disabled', val <= qtyMin);
				qtyPlus.classList.toggle('disabled', val >= qtyMax);
			};

			const updateMOQState = (val) => {
				const belowMOQ = val < qtyMOQ;
				if ( moqMessage ) moqMessage.style.display = belowMOQ ? '' : 'none';
				if ( addToCartBtn ) addToCartBtn.disabled = belowMOQ;
			};

			const applyPackSize = (step) => {
				qtyStep = step;
				qtyMOQ = step;
				qty.setAttribute('step', step);
				qty.setAttribute('data-moq', step);
				qty.value = step;
				updateDisabled(step);
				updateMOQState(step);
			};

			updateDisabled(parseInt(qty.value));
			updateMOQState(parseInt(qty.value));

			qty.addEventListener('change', (e) => {
				let val = parseInt(qty.value) || qtyMin;
				if ( val >= qtyMOQ ) {
					// Round up to nearest step multiple
					val = Math.ceil(val / qtyStep) * qtyStep;
				} else {
					// Below MOQ — clamp to min
					val = Math.max(qtyMin, val);
				}
				qty.value = val;
				updateDisabled(val);
				updateMOQState(val);
			});

			qtyMinus.addEventListener('click', (e) => {
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					// Above MOQ: step by pack size. At or below MOQ: step by 1
					const step = currentQty > qtyMOQ ? qtyStep : 1;
					const newQty = Math.max(qtyMin, currentQty - step);
					qty.value = newQty;
					updateDisabled(newQty);
					updateMOQState(newQty);
				}
			});

			qtyPlus.addEventListener('click', (e) => {
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					// Below MOQ: step by 1 up to MOQ, then snap to MOQ. At/above: step by pack size
					let newQty;
					if ( currentQty < qtyMOQ ) {
						newQty = currentQty + 1;
						// Snap to MOQ if we've reached it
						if ( newQty >= qtyMOQ ) newQty = qtyMOQ;
					} else {
						newQty = Math.min(qtyMax, currentQty + qtyStep);
					}
					qty.value = newQty;
					updateDisabled(newQty);
					updateMOQState(newQty);
				}
			});

			if ( packSizes ) {
				document.addEventListener('krown:variant:change', (e) => {
					const variantId = e.detail && e.detail.variant && e.detail.variant.id;
					if ( variantId && packSizes[variantId] ) {
						const newStep = packSizes[variantId];
						applyPackSize(newStep);
						const packSizeDisplay = document.querySelector('[data-pack-size-display]');
						if ( packSizeDisplay ) {
							packSizeDisplay.textContent = packSizeDisplay.dataset.packFormat === 'pack'
								? '/per pack'
								: `/per pair, pack of ${newStep}`;
						}
					}
				});
			}

		}

	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
